import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "max-size coral-light-color card-border image-supplier" }
const _hoisted_2 = ["src"]

import { IonIcon } from "@ionic/vue";
import { computed } from "vue";

import { useSupplierStore } from "@/stores/suppliers";

import { Supplier } from "@/types/supplier";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageSupplier',
  props: {
    supplierId: {}
  },
  setup(__props: any) {

const props = __props

const supplierStore = useSupplierStore()

const supplier = computed<Supplier | undefined>(() => supplierStore.supplierById(props.supplierId))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (supplier.value?.imageLink)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          alt: "",
          src: `https://app.octopusorder.com${supplier.value.imageLink}`,
          class: "max-size card-border"
        }, null, 8, _hoisted_2))
      : (supplier.value?.iconType)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 1,
            src: `assets/icon/${supplier.value.iconType}.svg`,
            class: "max-size card-border"
          }, null, 8, ["src"]))
        : (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 2,
            alt: "",
            src: "assets/icon/deliverer.svg",
            class: "max-size card-border"
          }))
  ]))
}
}

})